import { message } from 'antd';
import ls from 'utils/ls';

const actions = (dispatch) => ({
  initToken: (token, userInfo) => {
    ls.set('userInfo', userInfo)
    ls.set('token', token)
    dispatch({type: 'INIT_TOKEN', token, userInfo, forms: userInfo.forms})
  },
  logout: () => {
    ls.remove('userInfo')
    ls.remove('token')
    dispatch({type: 'LOGOUT'})
  },
  changeMenuKey: async (key) => {
    ls.set('mkey', key)
    dispatch({type: 'CHANGE_MENU_KEY', key})
  },
  handleSidebarCollapse: async (isCollapsed) => {
    if(isCollapsed){
      document.documentElement.style.setProperty('--sidebar-width', '344px')
    }
    else{
      document.documentElement.style.setProperty('--sidebar-width', '84px')
    }
    dispatch({type: 'CHANGE_SIDEBAR_WIDTH', sidebarCollapsed: isCollapsed})
  },
  connectionSocket: (connection) => {
    dispatch({ type: 'CONNECTION_SOCKET', socket: connection });
  },
  saveEmpProfileData: (data) => {
    dispatch({ type: 'SAVE_EMP_PROFILE_DATA', data: data });
  },
  onSuccess: (info) => {
    message.success(info)
  },
  setErrorStatus: (error) => {
    dispatch({ type: 'SET_ERROR_STATUS', error });
  },
  onError: (info, duration) => {
    if(duration){
      message.error(info, duration)
    }else{
      message.error(info, 5)
    }
  },
})

export default actions
